import { Pipe } from '@angular/core';
import { createRound, isString } from '../utils/utils';
var RoundPipe = (function () {
    function RoundPipe() {
    }
    RoundPipe.prototype.transform = function (value, precision) {
        if (precision === void 0) { precision = 0; }
        if (isString(precision)) {
            precision = parseInt(precision);
        }
        return createRound('round')(value, precision);
    };
    return RoundPipe;
}());
export { RoundPipe };
RoundPipe.decorators = [
    { type: Pipe, args: [{
                name: 'round'
            },] },
];
/** @nocollapse */
RoundPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=round.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/math/round.pipe.js
// module id = 267
// module chunks = 103